import React, { Component, Fragment } from 'react';
import Tooltip from '../../tooltip/Tooltip';

class OffersDisclaimer extends Component {
    render() {
        return (
            <div className="disclaimer">
                <br />
                <p className="sprk-b-TypeBodyFour">
          *The terms above are subject to the submission of a complete
          application within 5 days. After 5 days, your loan options will expire
          and you will need to resubmit your information. The payment, rate, and{' '}
                    <Tooltip
                        id="offersDisclaimerTip"
                        text="APR stands for Annual Percentage Rate and represents the total cost of borrowing as an annual rate."
                    >
                        <Fragment>
                            <span className="text-link">APR</span>
                        </Fragment>
                    </Tooltip>{' '}
          plus any finance charges are all estimates based upon your stated
          income and credit profile. If your income is verified to be less than
          your stated income and/or other factors in your credit profile change,
          your loan offers may also change. Reviewing these numbers and
          selecting a loan offer does not commit you to a loan.
                </p>
            </div>
        );
    }
}

export default OffersDisclaimer;
